import assetsLoader from 'assets-loader';
import {
  on,
  once,
  off,
} from './utils';

const isIOS = () => {

  const iDevices = [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ];

  if (!!navigator.platform) {
    while (iDevices.length) {
      if (navigator.platform === iDevices.pop()){ return true; }
    }
  }

  return false;
};

const blobs = {};

class Video {
  constructor({
    filePath
  }) {
    this.filePath = filePath;
    // this.el = this.createVideoEl();
    this.paused = true;
    this.loadPromise = null;
  }

  createVideoEl() {
    const videoEl = document.createElement('video');
    videoEl.setAttribute('playsinline', '');
    videoEl.setAttribute('webkit-playsinline', '');  // Support inline videos for iOS webviews.
    videoEl.controls = false;
    if (isIOS()) {
      videoEl.muted = true;
    }
    return videoEl;
  }

  load() {
    if (this.loadPromise) {
      return this.loadPromise;
    }
    this.loadPromise = new Promise((resolve, reject) => {
      const {el, filePath} = this;

      if (blobs[filePath]) {
        this.onLoadComplete();
        resolve();
        return;
      }

      const loader = assetsLoader({
        assets: [
          {
            id: `video_${filePath}`,
            blob: true,
            url: filePath,
          },
        ]
      })
        .on('error', function(error) {
          console.error(error);
          reject(error);
        })
        .on('progress', (progress) => {

        })
        .on('complete', (assets) => {
          blobs[filePath] = loader.get(`video_${filePath}`);
          this.onLoadComplete();
          resolve();
        })
        .start();
    });
    return this.loadPromise;
  }

  onLoadComplete() {
    const {filePath} = this;
    const blob = blobs[filePath];
    const el = this.createVideoEl();
    el.src = window.URL.createObjectURL(blob);
    el.style.display = 'none';
    el.className = 'App-videoCanvas';
    this.el = el;

    document.body.querySelector('.App-container').appendChild(el);
  }

  play() {
    this.paused = false;
    return new Promise((resolve, reject) => {
      once(this.el, 'ended', () => {
        this.paused = true;
        resolve();
      });

      this.el.play();
    });
  }

  pause() {
    this.paused = true;
    this.el.pause();
    off(this.el, 'ended', this.onPlayWithLoopEnded);
  }

  playWithLoop(data) {
    const {loopEndDuration} = data || {};
    once(this.el, 'ended', this.onPlayWithLoopEnded);
    if (loopEndDuration) {
      const timeupdate = () => {
        const currTime = this.el.currentTime;
        const fullTime = this.el.duration;
        const currPercent = currTime * 100 / fullTime;
        if (currPercent >= loopEndDuration) {
          off(this.el, 'timeupdate', timeupdate);
          off(this.el, 'ended', this.onPlayWithLoopEnded);
          this.el.pause();
          this.el.currentTime = 0;
          setTimeout(() => {
            if (!this.paused) {
              this.playWithLoop(data);
            }
          });

        }
      };
      on(this.el, 'timeupdate', timeupdate);
    }
    this.paused = false;
    this.el.play();
  }

  onPlayWithLoopEnded = (event) => {
    if (!this.paused) {
      this.playWithLoop();
    }
  }

  getCurrentTime() {
    return this.el.currentTime;
  }

  getDuration() {
    return this.el.duration;
  }

  getEl() {
    return this.el;
  }
}

export default Video;



/** WEBPACK FOOTER **
 ** ./src/client/video.js
 **/